export enum Colors {
  COLOR_WHITE = '#FFF',
  COLOR_ACCENT_500 = '#38C7AD',
  COLOR_SUCCESS_400 = '#69C9A3',
  COLOR_SUCCESS_700 = '#297054',
  COLOR_SUCCESS_500 = '#44BB8B',
  COLOR_NEUTRAL_300 = '#B2B2B3',
  COLOR_NEUTRAL_400 = '#98999A',
  COLOR_NEUTRAL_500 = '#7E8081',
  COLOR_NEUTRAL_600 = '#656667',
  COLOR_NEUTRAL_700 = '#4C4D4D',
  COLOR_NEUTRAL_800 = '#323334',
  COLOR_DANGER_400 = '#CE6464',
  COLOR_DANGER_500 = '#C23D3D',
  COLOR_DANGER_700 = '#742525',
  COLOR_WARNING_400 = '#E8BE4A',
  COLOR_WARNING_500 = '#E2AE1D',
  COLOR_WARNING_600 = '#B58B17',
  COLOR_WARNING_700 = '#876812',
}
